import { render, staticRenderFns } from "./bf-nav.vue?vue&type=template&id=5295da48&scoped=true&lang=pug&"
import script from "./bf-nav.vue?vue&type=script&lang=js&"
export * from "./bf-nav.vue?vue&type=script&lang=js&"
import style0 from "./bf-nav.vue?vue&type=style&index=0&id=5295da48&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5295da48",
  null
  
)

export default component.exports